<template>
  <div>
    <el-card v-if="dataForm.gameRankId">
      <div class="title">
        {{this.gameRankInfo.name}}
        &nbsp;&nbsp;&nbsp;
        <span
          v-if="this.gameRankInfo.status == 1"
        >已启用</span>
        <span v-else-if="this.gameRankInfo.status == 2">已停用</span>
        <span v-else-if="this.gameRankInfo.status == 3">已结束</span>
        <span v-else-if="this.gameRankInfo.status == 4">待审核</span>
        
        <el-button v-if="this.gameRankInfo.status == 4" type="danger" size="small" @click="addOrUpdateHandle(dataForm.gameRankId)" plain>修改</el-button>
        <el-button v-else type="success" size="small" @click="addOrUpdateHandle(dataForm.gameRankId)" plain>活动细则</el-button>
      </div>
      <br />
      <div class="time">
        <span>{{this.gameRankInfo.startTime}}</span>
        &nbsp;至&nbsp;
        <span>{{this.gameRankInfo.endTime}}</span>
      </div>
      <div class="data_list">
        <ul>
          <li>
            <div>{{this.gameRankInfo.participateInSum}}</div>
            <span>参与用户数</span>
          </li>
          <li>
            <div>{{this.gameRankInfo.winningThePrizeSum}}</div>
            <span>中奖用户数</span>
          </li>
          <li>
            <div>{{this.gameRankInfo.winningThePrizeCount}}</div>
            <span>中奖次数</span>
          </li>
        </ul>
      </div>
    </el-card>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="参与用户" name="first">
        <el-card shadow="never" class="aui-card--fill">
          <div class="mod-demo__gamerankuser}">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
              <el-form-item label="用户/账号">
                <el-input v-model="dataForm.accountName" placeholder="请输入用户姓名/账号" clearable></el-input>
              </el-form-item>
              <el-form-item label="开户时间">
                <el-date-picker
                  v-model="dataForm.openStartTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="年/月/日"
                ></el-date-picker>&nbsp;至&nbsp;
                <el-date-picker
                  v-model="dataForm.openEndTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="/年/月/日"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="dataForm.activationStatus" placeholder="全部" clearable>
                  <el-option label="已激活" value="1"></el-option>
                  <el-option label="未激活" value="2"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="激活时间">
                <el-date-picker
                  v-model="dataForm.activationStartTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="年/月/日"
                ></el-date-picker>&nbsp;至&nbsp;
                <el-date-picker
                  v-model="dataForm.activationEndTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="/年/月/日"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label="参与时间">
                <el-date-picker
                  v-model="dataForm.participateStartTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="年/月/日"
                ></el-date-picker>&nbsp;至&nbsp;
                <el-date-picker
                  v-model="dataForm.participateEndTime"
                  type="datetime"
                  value-format="timestamp"
                  placeholder="/年/月/日"
                ></el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button @click="queryDataList()">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="info"
                  @click="exportHandle('游戏活动参与用户')"
                >导出</el-button>
              </el-form-item>
            </el-form>
            <el-table
              v-loading="dataListLoading"
              :data="dataList"
              border
              @selection-change="dataListSelectionChangeHandle"
              style="width: 100%;"
            >
              <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
              <el-table-column fixed type="index" label="序号" :index="indexMethod" width="80"></el-table-column>
              <el-table-column prop="account" label="账号" header-align="center" align="center"></el-table-column>
              <el-table-column prop="accountName" label="用户" header-align="center" align="center"></el-table-column>
              <el-table-column
                prop="openAccountTime"
                label="真实开户时间"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="activationStatus"
                label="激活状态"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.activationStatus === 1" size="small" type="success">已激活</el-tag>
                  <el-tag
                    v-else-if="scope.row.activationStatus === 2"
                    size="small"
                    type="warning"
                  >未激活</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="activationTime"
                label="激活时间"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                  prop="gameRankCount"
                  label="总游玩次数"
                  header-align="center"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="gameRankCountSurplusSum"
                  label="可游玩次数"
                  header-align="center"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="gameRankMaxScore"
                  label="最高积分"
                  header-align="center"
                  align="center"
              ></el-table-column>
              <el-table-column
                prop="participateInTime"
                label="参与时间"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column 
                prop="netProceeds" 
                label="净入金" 
                header-align="center" 
                align="center"
              ></el-table-column>
              <!--<el-table-column
                prop="netAccountValue"
                label="账户净值"
                header-align="center"
                align="center"
              ></el-table-column>-->
              <el-table-column
                prop="tradingHandNumber"
                label="交易手数"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="closePosition"
                label="平仓盈亏"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="showBox(scope.row,3,'净入金')"
                    width="80"
                  >&nbsp;净入金&nbsp;&nbsp;</el-button>
                  <el-button
                    style="margin-left: 0"
                    size="mini"
                    @click="showBox(scope.row,4,'交易手数')"
                    width="80"
                  >交易手数</el-button>
                  <el-button
                    style="margin-left: 0"
                    size="mini"
                    @click="showBox(scope.row,6,'平仓盈亏')"
                    width="80"
                  >平仓盈亏</el-button>
                  <el-button
                    style="margin-left: 0"
                    size="mini"
                    @click="drawUpdateNumFunc(scope.row)"
                    width="80"
                  >修改游戏次数</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="pageSizeChangeHandle"
              @current-change="pageCurrentChangeHandle"
            ></el-pagination>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="游戏记录" name="second">
        <gamerank-Recode :gameRankId="dataForm.gameRankId"></gamerank-Recode>
      </el-tab-pane>
      <el-tab-pane label="黑名单" name="three">
        <gamerank-Black :gameRankId="dataForm.gameRankId"></gamerank-Black>
      </el-tab-pane>
    </el-tabs>
    <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" 
      @refreshDataList="getDataList"
      :productList="productList"

      ></add-or-update>
    <!-- 净入金 账户净值 交易手数弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showDetailBox">
      <el-table :data="detailData" border style="width: 100%">
        <el-table-column prop="account" label="账号" width="150"></el-table-column>
        <el-table-column
          prop="product"
          label="产品"
          header-align="center"
          align="center"
          v-if="typeFour == true"
        ></el-table-column>
        <el-table-column prop="result" label="值"></el-table-column>
        <el-table-column prop="time" label="时间" :formatter="timestampToDate"></el-table-column>
        
      </el-table>
      <div style="margin-top:20px;text-align:right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10,20,50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSize"
          ></el-pagination>
        </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDetailBox = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 弹窗, 修改游戏次数 -->
    <gamerankUpdateNum v-if="drawUpdateNum" :itemDrawId="itemDrawId" :account="itemAccount" :old-num="itemNum" ref="drawUpdateNumDl" @refreshDataList="queryDataList()"></gamerankUpdateNum>
  </div>
</template>

<script>
import mixinViewModule from "./import/view-module";
import AddOrUpdate from "./gamerank-add-or-update";
import gamerankRecode from "./gamerankrecord";
import gamerankBlack from "./gamerankblack";
import gamerankUpdateNum from "./gamerank-update-num";
import Url from '@/views/crs/util/url'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: Url.gameRank.base+"/activity/gameRankUser/page",
        getDataListIsPage: true,
        deleteURL: Url.gameRank.base+"/activity/gameRankUser",
        deleteIsBatch: true,
        exportURL: Url.gameRank.base+"/activity/gameRankUser/export"
      },
      titleName: "净入金",
      showDetailBox: false,
      typeFour: false,
      drawUpdateNum: false,
      itemDrawId: '',
      itemAccount:'',
      itemNum:'',
      detailData: [],
      currentPage: 1,
      pageSize:10,
      totalSize: 0,
      gameId:'',
      gameType :'',
      gameAccount :'',
      dataForm: {
        gameRankId: "",
        accountName: "",
        openStartTime: "",
        openEndTime: "",
        activationStatus: "",
        activationStartTime: "",
        activationEndTime: "",
        participateStartTime: "",
        participateEndTime: "",
        gameRankMaxScore:"",
        gameRankCountSurplus:"",
        gameRankCount:"",
        gameRankCountSurplusSum: "",
        netProceeds: "",
        tradingHandNumber: "",
        closePosition: ""
      },
      gameRankInfo: {
        name: "",
        status: "",
        startTime: "",
        endTime: "",
        participateInSum: 0,
        winningThePrizeSum: 0,
        winningThePrizeCount: 0
      },
      activeName: "first",
    };
  },
  components: {
    gamerankRecode,
    gamerankBlack,
    gamerankUpdateNum,
    AddOrUpdate
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    showBox(row, type, name) {
      this.gameId = row.gameRankId
      this.gameType = type
      this.gameAccount = row.account
      if (type == 4) {
        this.typeFour = true;
      } else {
        this.typeFour = false;
      }
      this.titleName = name;
      this.$axios
        .get(
          `${Url.gameRank.base}/activity/gameRankUser/getGameRankStatistics?gameRankId=${row.gameRankId}&type=${type}&account=${row.account}&pageSize=${this.pageSize}&pageNum=${this.currentPage}`
        )
        .then(res => {
          this.detailData = res.data.content;
          this.totalSize = res.data.totalElements
        });

      this.showDetailBox = true;
    },
    indexMethod(index) {
      return ++index;
    },
    loadDetail(id) {
      //活动面板信息初始化
      this.$axios
        .get(`${Url.gameRank.base}/activity/gameRankUser/getGameRankInfo?gameRankId=` + id)
        .then(res => {
          this.gameRankInfo = {
            ...this.gameRankInfo,
            ...res.data
          };
        });
    },
     handleSizeChange(val) {
      this.pageSize = val;
      this.getTabData();
    },
    getTabData(){
      
      this.$axios
        .get(
          `${Url.gameRank.base}/activity/gameRankUser/getGameRankStatistics?gameRankId=${this.gameId}&type=${this.gameType}&account=${this.gameAccount}&pageSize=${this.pageSize}&pageNum=${this.currentPage}`
        )
        .then(res => {
          this.detailData = res.data.content;
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTabData();
    },
    // 上传文件
    drawUpdateNumFunc (row) {
      this.itemDrawId = row.gameRankId
      this.itemAccount = row.account
      this.itemNum = row.gameRankCountSurplusSum
      this.drawUpdateNum = true
      this.$nextTick(() => {
        this.$refs.drawUpdateNumDl.init()
      })
    },
  },
  created() {
    this.dataForm.gameRankId = this.$route.query.id;
    this.loadDetail(this.dataForm.gameRankId);
    this.queryDataList();
  },
  watch: {
    $route(to, from) {
      window.location.reload()
      if (to.query.id != from.query.id) {
        this.dataForm.gameRankId = to.query.id;
        this.loadDetail(this.dataForm.gameRankId);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
  span {
    border-radius: 8px;
    background: #0096dc;
    text-align: center;
    padding: 5px;
    color: #fff;
    font-size: 12px;
  }
}
.time {
  font-size: 14px;
  color: #999;
}
.data_list {
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    li {
      text-align: center;
      div {
        font-size: 26px;
        color: #333;
      }
      span {
        font-size: 14px;
        color: #999;
      }
    }
  }
}
ul,
li {
  list-style: none;
}
</style>
